export default __webpack_public_path__ + "static/media/popup_rapid_graph.e65e72ee.jpg";